import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";


export const isSatisfactionSurveyAvailable = (uID, successCallback, errorCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/customer-insights-survey/${uID}/available`,
    mountedRef: mountedRef,
    successCallback: successCallback,
    errorCallback: errorCallback
  });    
};

export const setSatisfactionSurvey = (uID, payload, successCallback, errorCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_POST,
    endpoint: `/customer-insights-survey/${uID}`,
    payload: payload,
    mountedRef: mountedRef,
    successCallback: successCallback,
    errorCallback: errorCallback
  });
};

export const getSatisfactionSurvey = (supportCallId, successCallback, errorCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/customer-insights-survey/${supportCallId}`,
    successCallback: successCallback,
    errorCallback: errorCallback,
    mountedRef: mountedRef,
  });
};